// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__aS7Ch","rotate":"Loader_rotate__aQhEY"};